define('common/cleanBFCache',[], function() {
	window.onunload = function() {
		console.log('window is unloading! No BFCache shall apply');
	};
});
